import script from "./ProductDeatils.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDeatils.vue?vue&type=script&setup=true&lang=js"

import "./ProductDeatils.vue?vue&type=style&index=0&id=04ee357a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04ee357a"]])

export default __exports__